<div class="dropdowns-row" [formGroup]="formGroup">
  <div class="dropdown-field">
    <pdq-dropdown
      title="Border"
      formControlName="border"
      [options]="borderOptions"
      optionLabel="label"
      optionValue="value">
    </pdq-dropdown>
  </div>
  <div class="dropdown-field">
    <pdq-dropdown
      title="Border Width"
      formControlName="borderWidth"
      [options]="borderWidthOptions"
      optionLabel="label"
      optionValue="value">
    </pdq-dropdown>
  </div>
  <div class="dropdown-field">
    <pdq-dropdown
      title="Corner Radius"
      formControlName="cornerRadius"
      [options]="cornerRadiusOptions"
      optionLabel="label"
      optionValue="value">
    </pdq-dropdown>
  </div>
  <div class="dropdown-field">
    <pdq-dropdown
      title="Padding"
      formControlName="padding"
      [options]="paddingOptions"
      optionLabel="label"
      optionValue="value">
    </pdq-dropdown>
  </div>
</div>
